
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";

interface DeleteAllCodesDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  onDeleteAll: () => Promise<void>;
  isDeleting: boolean;
}

export const DeleteAllCodesDialog = ({
  isOpen,
  onOpenChange,
  onDeleteAll,
  isDeleting,
}: DeleteAllCodesDialogProps) => {
  return (
    <AlertDialog open={isOpen} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>¿Estás seguro?</AlertDialogTitle>
          <AlertDialogDescription>
            Esta acción eliminará permanentemente TODOS los códigos de este lanzamiento y no se podrán recuperar.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isDeleting}>Cancelar</AlertDialogCancel>
          <AlertDialogAction onClick={onDeleteAll} disabled={isDeleting} className="bg-red-600 hover:bg-red-700">
            {isDeleting ? "Eliminando..." : "Eliminar todos"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
